import { render, staticRenderFns } from "./BudgetDuration.vue?vue&type=template&id=2462c1fc&"
import script from "./BudgetDuration.vue?vue&type=script&lang=js&"
export * from "./BudgetDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports